const ChangePasswordReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default ChangePasswordReducer;
